<template>
    <div class="introduction">
        <menuBox :step="6"></menuBox>
        <div class="banner">
            公司簡介
            <p>FIRESTORM TECH
                LIMITED公司是中國最具實力的跨境數字營銷服務商之一，專注於為外貿企業提供以效果為導向的數字營銷服務。公司立足全球客戶，佈局海外，整合大量海外優質營銷資源，幫助國內出口企業獲取優質海外用戶，提供最具針對性的互聯網營銷解決方案。
            </p>
        </div>
        <div class="introduction-item">
            <div class="item-box">
                <img src="../assets/img-12.png" alt="">
                <div class="item-text">
                    <div class="title">公司歷史</div>
                    <div class="text">
                        公司擁有5年以上海外營銷經驗。他們擁有豐富的行業經驗，服務客戶超過10000家。涵蓋的領域包括遊戲、電商、婚紗等。我們積累了豐富的產品海外推廣創意和實踐經驗，滿足不同市場的推廣需求，為營銷公司降低營銷成本，快速抓住潛在用戶。
                    </div>
                </div>
            </div>
            <div class="item-box top-px">
                <img src="../assets/img-13.png" alt="">
                <div class="item-text">
                    <div class="title">我們的服務</div>
                    <div class="text">
                        ● 優質流量資源
                        <br> ● 完善的技術支持
                        <br> ● 專業運營團隊
                        <br> ● 豐富的海外推廣經驗
                    </div>
                </div>
            </div>
            <div class="item-box top-px">
                <img src="../assets/img-14.png" alt="">
                <div class="item-text">
                    <div class="title">我們的團隊</div>
                    <div class="text">
                        ● 銷售團隊——來自互聯網多個領域的資深行業解決方案專家
                        <br> ● 優化團隊- 覆蓋10+ 種語言，幫助在全球市場推廣數字營銷。
                        <br> ● 設計團隊——創意設計+視頻設計，擅長多類型創意製作
                        <br> ● 運營團隊-來自國內相關頂尖大學的頂尖人才
                    </div>
                </div>
            </div>
        </div>

        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.banner {
    width: 100%;
    height: 480px;
    background: url(../assets/banner-3.png);
    background-size: 100% 100%;
    font-size: 40px;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    p {
        padding: 24px 360px;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
    }
}

.introduction-item {
    padding: 120px 360px;

    .top-px {
        margin-top: 80px;
    }

    .item-box {
        display: flex;

        // justify-content: space-between;
        img {
            width: 470px;
            height: 320px;
        }

        .item-text {
            margin-left: 40px;

            .title {
                font-size: 32px;
                font-weight: 500;
                color: #1C539D;
            }

            .text {
                font-size: 18px;
                font-weight: 500;
                color: #999999;
                margin-top: 16px;
            }
        }
    }
}
</style>